import * as ReactDOM from "react-dom";
import * as React from "react";
import Main from "./components/Main";
import { BrowserRouter as Router } from "react-router-dom";
import Config from "./interfaces/Config";

var _config: Config = {} as Config;

export const Config = () => _config;

fetch("config.json").then(resp => resp.json()).then((config:Config) => {
    _config = config;
    ReactDOM.render(<Router basename={config.baseName}><Main /></Router>, document.querySelector("#app"));
}).catch(ex => {
    alert("Nepodařilo se načíst config.json!");
})
